<!--
右下角浮动按钮
最近更新：20200318
-->
<template>
  <div>
    <div class="pc_footer"
      v-lazy:background-image="{
        src: './static/img/footer_pc.png',
        error: './static/img/footer_pc.png'
      }"
    >
      捷安特（昆山）有限公司
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageFooter',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {
    const _this = this;
  },
  mounted() {
  },
  destroyed() {},
  methods: {
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue